import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});



// Function to handle fetch requests
export async function fetchDataApi(url: string, options: RequestInit = {}): Promise<any> {

  try {
    const response = await authService.apiCall(`${BASE_URL}/${url}`, {
      ...options,
   
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    //////console.log(error)
    throw new Error(error?.message || error || 'Failed to fetch data');
  }
}



// Function to handle fetch requests
export async function fetchAllDataApi( options: RequestInit = {}): Promise<any> {

  try {
    const response = await authService.apiCall(`${BASE_URL}/risks/getAll`, {
      ...options,
    
    });

    const data = await response.json();

    if (!response.ok ) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    //////console.log(error)
    throw new Error(error?.message || error || 'Failed to fetch data');
  }
}


export async function createRiskApi(body: any): Promise<void> {
  try {

    const response = await authService.apiCall(`${BASE_URL}/cbe-risks`, {
      method: "POST",
    
      body: JSON.stringify({
        question: body.question, // Description
        categoryId: body.categoryId, // Category ID
      }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to create risk");
    }
    return data.data;
  } catch (error: any) {
    throw new Error(error?.message || error || 'Failed to create risk');
  }
}

export async function fetchOneApi(url: string, options: RequestInit = {}): Promise<any> {
  try {
    

    const fullUrl = `${BASE_URL}/${url}`; // Construct the full URL
    //console.log("Fetching from URL:", fullUrl); // Log the URL

    const response = await authService.apiCall(fullUrl, {
      ...options,
    
    });

    const data = await response.json();
    //console.log("API Response:", data); // Log the response

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }

    return data;
  } catch (error: any) {
    console.error("Error in fetchOneApi:", error); // Log the error
    throw new Error(error?.message || error || 'Failed to fetch data');
  }
}

export async function updateRiskApi(id: any, body: any): Promise<void> {
  try {
    
    const fullUrl = `${BASE_URL}/cbe-risks/${id}`; // Construct the full URL

    const response = await authService.apiCall(fullUrl, {
      method: "PATCH",
     
      body: JSON.stringify(body),
    });

    const data = await response.json();
    //console.log("Update API Response:", data); // Log the response

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to update");
    }

    return data; // Return the response data
  } catch (error) {
    console.error("Error in updateRiskApi:", error); // Log the error
    throw new Error("Failed to update risk");
  }
}


export async function deleteRiskApi(id: string): Promise<void> {
  try {

    const response = await authService.apiCall(`${BASE_URL}/cbe-risks/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error('Failed to delete risk');
    }
    return response.json(); // Return the response data
    // Optionally return response data if needed
  } catch (error) {
    throw new Error('Failed to delete risk');
  }
}


export async function fetchAllCategoryDataApi(): Promise<any> {
  try {
      const response = await authService.apiCall(`${BASE_URL}/categories/getAll`, {
        method: "GET",
      });

      // Check if response is ok before trying to parse JSON
      if (!response.ok) {
        // Handle CORS/preflight errors
        if (response.status === 0 || response.type === 'opaque' || response.type === 'opaqueredirect') {
          console.error("CORS error: Failed to fetch categories. Check server CORS configuration.");
          // Return empty array instead of throwing to prevent page break
          return { success: true, data: [] };
        }
        
        if (response.status === 401 || response.status === 403) {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        
        // Try to get error message from response
        let errorMessage = `Failed to fetch categories: ${response.status} ${response.statusText}`;
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } catch {
          // If JSON parsing fails, use the status message
        }
        throw new Error(errorMessage);
      }

      const data = await response.json();
      
      // Handle different response structures
      if (data.success !== undefined) {
        if (!data.success) {
          // Don't throw, just return empty data to prevent page break
          console.warn("Categories API returned success=false:", data.message);
          return { success: true, data: [] };
        }
        return data;
      }
      
      // If no success field, assume data is valid
      return { success: true, data: Array.isArray(data) ? data : (data.data || []) };
  } catch (error: any) {
      console.error("fetchAllCategoryDataApi error:", error);
      // Return empty array instead of throwing to prevent page break
      // The component will handle empty arrays gracefully
      return { success: true, data: [] };
  }
}


export async function fetchAllAreasDataApi(): Promise<any> {
  try {
     

      const response = await authService.apiCall(`${BASE_URL}/impacted-areas`, {
        method: "GET",

      });

      const data = await response.json();
      if (!response.ok || !data.success) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          throw new Error("Failed to fetch");
      }
      return data;
  } catch (error: any) {
      throw new Error(error?.message || error || 'Failed to fetch data');
  }
}


export async function assesstRisk(body: any): Promise<any> {
  try {
  
    
    const response =await authService.apiCall(`${BASE_URL}/cbe-risk-assessment`, {
      method: 'POST',
     
      body: JSON.stringify(body),
    });

      const data = await response.json();
      if (!response.ok || !data.success) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          throw new Error("Failed to fetch");
      }
      return data;
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function getRiskAssessmentByQuarter(riskId: any, quarter: string): Promise<any> {
  try {
   
    const response = await authService.apiCall(`${BASE_URL}/cbe-risk-assessment/${riskId}/quarter/${quarter}`, {
      method: 'GET',
  
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
}





